import { createSlice } from '@reduxjs/toolkit';

export const newsletter = createSlice({
  name: 'NEWSLETTER',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    setSubscriptionStatus(state, action) {
      return {
        ...state,
        subscriptionStatus: action.payload?.subscriptionStatus,
      };
    },
    setDynamicNewsletterName(state, action) {
      return {
        ...state,
        dynamicNewsletterName: action.payload?.dynamicNewsletterName,
      };
    },
  },
});

const { actions, reducer } = newsletter;

export const {
  setHasInteractedWithNewsletter,
  setSubscriptionStatus,
  setDynamicNewsletterName,
} = actions;

export default reducer;
